import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { trackError } from 'helpers/ErrorUtils';
import type { AppDispatch } from 'entrypoints/bootstrapOnClient';
import { fetchCustomerAuthDetails } from 'actions/authentication';
import { fetchAccountInfo } from 'actions/account/account';

const useFetchAccountInfo = (isCustomer: boolean) => {
  const dispatch: AppDispatch = useDispatch();
  useEffect(() => {
    const fetchDetails = async () => {
      try {
        if (isCustomer) {
          dispatch(fetchAccountInfo());
        }
      } catch (error) {
        trackError('Error fetching customer auth details:', 'ERROR');
      }
    };

    fetchDetails();
  }, [fetchAccountInfo, fetchCustomerAuthDetails]);
};

export default useFetchAccountInfo;
